import { safeParse } from 'shouldve-been-js';
import OrderValidationResultMessage from './OrderValidationResultMessageModel';

class OrderValidationResult {

    private _isValid: boolean;
    private _messages: OrderValidationResultMessage[];

    public constructor(isValid: boolean, messages: OrderValidationResultMessage[]) {

        this._isValid = isValid;
        this._messages = messages;
    }

    public get isValid(): boolean {
        return this._isValid;
    }

    public set isValid(value: boolean) {
        this._isValid = value;
    }

    public get messages(): OrderValidationResultMessage[] {
        return this._messages;
    }

    public set messages(value: OrderValidationResultMessage[]) {
        this._messages = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): OrderValidationResult {

        const isValid: boolean = safeParse<boolean>(json?.IsValid, false);
        
        let messages: OrderValidationResultMessage[] = [];

        if (Array.isArray(json?.Messages)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
            messages = json.Messages.map((tabObject: any) => {
                return OrderValidationResultMessage.fromJson(tabObject);
            }); 
        }

        return new OrderValidationResult(isValid, messages);
    }
}

export default OrderValidationResult;